module.exports = __webpack_public_path__ + "img/fire_tool_6.6ec4b047.png";